import {
  Component
} from '@angular/core';
import {
  FormControl,
  FormGroup
} from '@angular/forms';
import {
  ActivatedRoute,
  NavigationEnd,
  Router
} from '@angular/router';
import {
  Observable
} from 'rxjs';

import {
  ApiService
} from './services/api/api.service';
import {
  GlobalsService
} from './services/globals/globals.service';
import {
  filter,
  switchMap
} from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public title = 'ProtonDash';
  private history = [];



  constructor(public globals: GlobalsService, private api: ApiService, private router: Router, private route: ActivatedRoute) {

    this.globals.showGatekeeper = false;
    let url_string = window.location.href;
    var url = new URL(url_string);

    if (url.searchParams.get("key")) {

      this.globals.showActivation = true;
      let key = url.searchParams.get("key");
      //if Key do activate
      if (key) {

        this.api.activate(key, () => {

          this.globals.showActivation = true;

          this.globals.activationResult = true;
          this.globals.showGatekeeper = true
        }, () => {

          this.globals.showActivation = true;

          this.globals.activationResult = false;
          this.globals.showGatekeeper = true
        });
      } else {
        this.globals.showGatekeeper = true
      }
    } else if (url.searchParams.get("token")) {
      this.globals.resetToken = url.searchParams.get("token");
      this.globals.isReset = true;

    } else {
      this.globals.showGatekeeper = true
    }

  }

  ngOnInit() {}


}
